<section class="dialog-header" mat-dialog-title>
  <h2 class="m-0 text-lg font-semibold">{{ title }}</h2>
  <button mat-icon-button type="button" (click)="close()" aria-label="Close details dialog">
    <mat-icon>close</mat-icon>
  </button>
</section>

<div mat-dialog-content class="dialog-content">
  <div class="mb-3 text-sm text-gray-500">
    Post ID: {{ post.id ?? post._id ?? '-' }}
  </div>

  <section class="mb-4">
    <h3 class="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-600">Images</h3>
    <ng-container *ngIf="data.media.length; else noMedia">
      <div class="relative aspect-[4/3] overflow-hidden rounded-lg bg-gray-100">
        <app-photo-strip [media]="data.media" alt="Post photo" arrows="always" [width]="800" sizes="40rem"></app-photo-strip>
      </div>
    </ng-container>
    <ng-template #noMedia>
      <div class="rounded border border-dashed border-gray-300 bg-gray-50 p-4 text-sm text-gray-500">
        No media images attached to this post.
      </div>
    </ng-template>
  </section>

  <section>
    <h3 class="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-600">Details</h3>
    <div class="details-grid">
      <div class="detail-row" *ngFor="let item of postDetails">
        <span class="label">{{ item.label }}</span>
        <span class="value">{{ item.value }}</span>
      </div>
    </div>
  </section>
</div>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
